module.exports = __webpack_public_path__ + "static/media/Fair_Chase_text.1cb14e27.png";